exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".descriptionLines__InvoiceSubjectListItem-module___35-qJ {\n  font-weight: 600;\n  font-family: 'Poppins', sans-serif;\n  font-size: 12px;\n}\n", ""]);

// Exports
exports.locals = {
	"descriptionLines": "descriptionLines__InvoiceSubjectListItem-module___35-qJ"
};